var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b1t-okraina-catalog-section"},[(!_vm.section.stub)?_c('div',[(_vm.section.SECTIONS_CNT > 0)?_c('div',[_c('b1t-okraina-catalog-sections',{attrs:{"parent":this.section.ID}})],1):_vm._e()]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }